import React from 'react';
import { City, SiteConfig, CountryState } from '@firsttable/types';
import type { RedirectPagePropTypes } from '../templates/RedirectPage';

export type GlobalRegion = City & {
  latitude?: number | null;
  longitude?: number | null;
};

export type GlobalState = {
  navigation?: any[];
  siteConfig?: SiteConfig | null;
  companySites?: Array<Pick<
    SiteConfig,
    'websiteURL' | 'facebookURL' | 'instagramURL'
  > | null> | null;
  globalSite?: Pick<SiteConfig, 'websiteURL' | 'facebookURL' | 'instagramURL'> | null;
  isMinorSite?: boolean;
  isGlobalSite?: boolean;
  countryStates?: CountryState[] | null;
  regions?: GlobalRegion[] | [];
  serverSideRenderedDate?: string | null;
};

export type AppState = {
  global: GlobalState;
  // @todo make this specific page types
  page?: any;
  preview?: boolean;
  force?: boolean;
  redirect?: RedirectPagePropTypes;
  [k: string]: unknown; // allow for any other props
};

export const defaultContext: AppState = {
  global: {
    navigation: [],
    siteConfig: null,
    countryStates: null,
    regions: [],
    serverSideRenderedDate: null,
  },
  page: {
    __typename: 'Page',
    title: '',
    blocks: [],
  },
};

const SilverstripeContext = React.createContext(defaultContext);

export default SilverstripeContext;
